import "../../styles/leaveManagement.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import LeaveManagementTable from "./LeaveManagementTable";
import UtilityBarDates from "../../components/Reusable/UtilityBarDates";
import LeaveCalendar from "../../components/Reusable/LeaveCalendar";

import useCompanyStore from "../../store/useCompanyStore";
import useSelectedCompanyStore from "../../store/useSelectedCompanyStore";
import { useLeaveManagementStore } from "../../store/useLeaveManagementStore";
import DownloadEmployeeLeaveDetails from "./DownloadEmployeeLeaveDetails";

import LeaveSummaryCards from "./components/LeaveSummaryCards";
import LeaveManagementHeader from "./components/LeaveManagementHeader";
import { getLeaveStats } from "./utils/leaveStats";
import useLeaveDateFilter from "./hooks/useLeaveDateFilter";

const LeaveManagement = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { companyList, fetchCompanies } = useCompanyStore();
  const { selectedCompany, setSelectedCompany } = useSelectedCompanyStore();

  const [viewLeaveCalendar, setViewLeaveCalendar] = useState(false);
  const [openDownloadLeavesPopup, setOpenDownloadLeavesPopup] = useState(false);

  const navigate = useNavigate();
  const loggedEmployeeId = userData.user[0]?.employee_id;

  const { attendanceData, getEmployeeLeaveData } = useLeaveManagementStore();

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  const currentManager =
    attendanceData
      ?.flatMap((data) => data?.approving_managers_status || [])
      .find((manager) => manager.emp_id === loggedEmployeeId) || null;

  const currentManagerApprovalStatus = currentManager?.status;

  const { totalLeaveRequests, totalLeavesApproved, totalLeavePending } =
    getLeaveStats(attendanceData, currentManagerApprovalStatus);

  const getCurrentMonthDates = () => {
    const currentDate = new Date();

    const monthEnd = currentDate.toISOString().substr(0, 10);

    const nintyDaysAgo = new Date(
      currentDate.getTime() - 180 * 24 * 60 * 60 * 1000,
    );

    const monthStart = nintyDaysAgo.toISOString().substr(0, 10);
    return {
      monthStart,
      monthEnd,
    };
  };

  const { monthStart, monthEnd } = getCurrentMonthDates();
  const {
    startDate,
    endDate,
    selectedStartDate,
    selectedEndDate,
    minDate,
    view,
    setView,
    startDateOnChange,
    endDateOnChange,
    clearAllDates,
    searchButtonClick,
  } = useLeaveDateFilter({
    getEmployeeLeaveData,
    monthStart,
    monthEnd,
  });

  useEffect(() => {
    getEmployeeLeaveData(
      monthStart,
      monthEnd,
      navigate,
      selectedCompany?.name || "",
    );
  }, [selectedCompany, monthStart, monthEnd, navigate, getEmployeeLeaveData]);

  const handleLeaves = (route, stateKey) => {
    navigate(route, {
      state: { [stateKey]: attendanceData },
    });
  };

  const onCompanyChange = (e) => {
    if (!e.target.value) {
      setSelectedCompany(null);
      return;
    }

    const company = companyList.find((c) => c.company_name === e.target.value);

    if (company) {
      setSelectedCompany({
        id: company.id,
        name: company.company_name,
      });
    }
  };

  console.log("Attendance Data", attendanceData)

  return (
    <div className="w-full pt-0 px-7 pb-12">
      <LeaveManagementHeader
        companyList={companyList}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        onChange={onCompanyChange}
        onCalendarClick={() => setViewLeaveCalendar(true)}
        onDownloadClick={() => setOpenDownloadLeavesPopup(true)}
      />

      {viewLeaveCalendar && (
        <div className="absolute inset-0 w-full h-max bg-white z-50">
          <LeaveCalendar
            selectedCompany={selectedCompany?.name || ""}
            setViewLeaveCalendar={setViewLeaveCalendar}
          />
        </div>
      )}
      <LeaveSummaryCards
        totalLeaveRequests={totalLeaveRequests}
        totalLeavesApproved={totalLeavesApproved}
        totalLeavePending={totalLeavePending}
        onCardClick={handleLeaves}
      />
      <UtilityBarDates
        startDate={startDate}
        endDate={endDate}
        selectedStartDate={selectedStartDate}
        selectedEndDate={selectedEndDate}
        minDate={minDate}
        view={view}
        setView={setView}
        startDateOnChange={startDateOnChange}
        endDateOnChange={endDateOnChange}
        clearAllDates={clearAllDates}
        searchButtonClick={searchButtonClick}
        attendanceData={attendanceData}
      />
      <LeaveManagementTable
        attendanceData={attendanceData}
        selectedCompany={selectedCompany?.name || ""}
        selectedCompanyId={selectedCompany?.id}
        currentManagerApprovalStatus={currentManagerApprovalStatus}
        loggedEmployeeId={loggedEmployeeId}
        getEmployeeMonthWiseLeave={() =>
          getEmployeeLeaveData(monthStart, monthEnd, selectedCompany)
        }
      />
      {openDownloadLeavesPopup && (
        <DownloadEmployeeLeaveDetails
          selectedCompanyId={selectedCompany?.id}
          setOpenDownloadLeavesPopup={setOpenDownloadLeavesPopup}
        />
      )}
    </div>
  );
};

export default LeaveManagement;
